import { Input, Select, Flex, Typography, Tooltip } from "antd"
import { styled, useTheme } from "styled-components"

const { Text } = Typography

// Extract the base type by stripping everything after and including the parentheses
// e.g., VARCHAR(164) -> VARCHAR
//       DECIMAL(38,0) -> DECIMAL
//       TIMESTAMP(6) WITH EXTRA STUFF -> TIMESTAMP
const getShortType = (type: string) => type.split("(")[0].trim()

// This styled component is a temporary workaround to truncate the type text,
// will be removed with the next design iteration to replace text with icons
const TypeText = styled(Text)`
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
`

type ColumnNameSelectorProps = {
  onChange: (value: string) => void
  label: string
  path: string
  options?: { value: string; label: string; type?: string }[]
}

export const ColumnNameSelector = ({ options, onChange, label, path, ...rest }: ColumnNameSelectorProps) => {
  const theme = useTheme()

  return (
    <>
      {options && (
        <Select
          {...rest}
          onChange={(option) => {
            onChange(option)
          }}
          showSearch
          placeholder="Select a column"
          aria-label={`Select ${label}`}
          options={options}
          optionRender={(option) => (
            <Tooltip title={option.data.type}>
              <Flex justify="space-between" align="center" gap={theme.spacing.xxs} style={{ width: "100%" }}>
                <span>{option.label}</span>
                {option.data.type && <TypeText type="secondary">{getShortType(option.data.type)}</TypeText>}
              </Flex>
            </Tooltip>
          )}
          filterOption={(inputValue, option) => {
            const optionValue = option?.value?.toString() || ""
            return optionValue.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }}
        />
      )}
      {!options && (
        <Input
          {...rest}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Enter a column name"
          aria-label={label}
          autoComplete="off"
        />
      )}
    </>
  )
}
